import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import DropdownAction from "../../components/dropdown/DropdownAction";
import Table from "../../components/table/Table";
import ActionContainer from "../../components/UIComponent/ActionTableComponent/actionContainer";
import BookingServices from "../../services/axiosServices/apiServices/BookingServices";
import moment from "moment";
import SwalServices from "../../services/swalServices/SwalServices";
import { encryptAES } from "../../utils/Encryption";
import EditViewNewBooking from "../../components/booking/EditViewNewBooking";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../utils/Messages";
import { getAuthProps } from "../../utils/AuthenticationLibrary";

export default class ViewNewBookings extends Component {
  constructor(props) {
    super(props);
    this.BookingServices = new BookingServices();
    this.swalServices = new SwalServices();
    this.state = {
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        dateFrom: "",
        dateTo: "",
        selectedEvent: [],
      },
      actionDropdown: ["Detail", "Edit"],
      route: "",
      totalResultes: "",
      bookingList: [],
      isLoading: false,
      bookingDetails: {
        bookingAttendeeInformationId: 0,
        bookingId: 0,
        bookingReferenceNo: 0,
        bookingDate: "",
        eventTypeName: "",
        attendeeName: "",
        subTotalPrice: "",
        discountPrice: "",
        totalPrice: ""
      },
      setEditViewNewBooking: false,
      adminUserId: null,
      editViewNewBooking: {
        bookingAttendeeInformationId: 0,
        attendeeName: "",
        contactNo: "",
        companyName: "",
        emailAddress: ""
      },
      eventNameList: [],
      isDataGetByDropdown: false,
      isDownloadingExcel: false,
      validationRule: {
        attendeeName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "attendee name"
            ),
          },
        ],
        contactNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "contact number"
            ),
          },
        ],
        companyName: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "company name"
            ),
          },
        ],
        emailAddress: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "email address"
            ),
          },
          {
            type: "email",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "valid email address"
            ),
          },
        ],



      },
      validState: {
        isValid: true,
        error: {},
      },
    }
  }

  //BookedEventName

  // handleChangeMultiDropdown(selected, identity) {
  //   let data = this.state.pagination;
  //   if (identity === "EventName") {
  //     data.selectedEvent = selected;
  //     data.searchText = ""
  //     let found = this.state.eventNameList.find(x => x.label === selected.label);
  //     if (found) {
  //       data.pageNo = 1;
  //       data.pageSize = 10;
  //       data.searchText = found.label;
  //     }
  //     this.setState({ pagination: data }, () => {
  //       this.getbookingsList(this.state.pagination);
  //     });
  //   }
  // }

  // downloadBookingSheetByEventId = () => {
  //   this.setState({ isDownloadingExcel: true });
  //   if (this.state.pagination.selectedEvent?.value && this.state.pagination.selectedEvent.value > 0) {
  //     let request = [];
  //     request.push(this.state.pagination.selectedEvent.value);
  //     this.BookingServices.downloadBookingSheetByEventId(request).then((response) => {
  //       if (response.status === 200 && response.data != null) {
  //         // var filename = `${detail}${formattedDate}`;
  //         let blob = new Blob([response.data])
  //         saveAs(blob, `${this.state.pagination.selectedEvent.label}_Bookings` + ".xlsx");
  //       }
  //       else {
  //         this.swalServices.Error(response.message);
  //       }
  //       this.setState({ isDownloadingExcel: false });
  //     });
  //   }

  // }

  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getbookingsList(newPagination);
  };
  getAllDropdownsForIndividualBooking = () => {
    this.BookingServices.getAllDropdownsForIndividualBooking().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let eventArr = response.responseItem.responseContent.filter(drp => drp.dropdownName === 'BookedEventName');

        eventArr.map(function (item) { delete item['dropdownName']; return item; });
        eventArr = eventArr.map(p => ({
          value: p.id, label: p.name
        }));
        this.setState({ eventNameList: eventArr });
      } else {
        this.SwalServices.Error(response.message);
      }
    });
  }
  getbookingsList = (pagination = this.state.pagination) => {
    this.setState({ isLoading: true });
    this.BookingServices.getbookingsList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent.itemList;
        details.map((key, index) => {
          key.bookingDate = moment(key.bookingDate).format(
            "DD MMM YYYY"
          );
          return key;
        });
        this.setState({ bookingList: details }, () => {
          let pagData = { ...this.state.pagination }
          //pagData.selectedEvent = [];
          if (pagination?.selectedEvent != null && pagination.selectedEvent.label && pagination.selectedEvent.value > 0) {
            this.setState({ isDataGetByDropdown: true, pagination: pagData });
          } else {
            this.setState({ isDataGetByDropdown: false, pagination: pagData });
          }
        });
        this.setState({
          totalResultes: response.responseItem.responseContent.totalCount,
        });
      } else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    });
  };

  actionClick = (index, value, option, event) => {
    this.getNewBookingDetailsById(value);

    if (option === "Detail") {
      if (value && value > 0) {
        let details = this.state.bookingList;
        let bookingDetails = details.find((x) => x.bookingAttendeeInformationId === value)
        if (bookingDetails) {
          this.setState({
            route: "/financial/ViewBookingDetail/" + encryptAES(value) + "/" + encryptAES(bookingDetails.bookingId)
          });
        }
      }
    }
    if (option === "Edit") {
      if (value && value > 0) {
        let editViewNewBooking = this.state.editViewNewBooking;
        if (editViewNewBooking) {
          event.stopPropagation();
          this.setState({ setEditViewNewBooking: true });
        }
      }

    }
  };

  actions = (element, index, value) => {
    return element !== "BookingAttendeeInformationId" ? null : (
      <td>
        <div className="relative w-full credit-note-action-dropdown">
          <ActionContainer>
            <div className="mr-8">
              <DropdownAction
                key={index}
                value={value}
                id={index}
                index={index}
                options={this.state.actionDropdown}
                align="right"
                onOptionClick={this.actionClick.bind(this)}
              />
            </div>
          </ActionContainer>
        </div>
      </td>
    );
  };

  searchByName = (value) => {
    let detail = this.state.pagination;
    detail.searchText = "";
    this.setState({ pagination: { ...detail } });
    if (value.length > 2) {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getbookingsList();
  };

  handleChange(event) {
    const value = event.target.value;
    const name = event.target.name;
    let detail = this.state.pagination;
    let fulldate = (detail[name] = value === "" ? null : value);
    let date = new Date(fulldate); //1/1/1753 12:00:00 AM and 12/31/9999 11:59:59 PM
    let startLimit = new Date("1/1/1753 12:00:00 AM");
    let endLimit = new Date("12/31/9999 11:59:59 PM");
    detail[name] = value;
    this.setState({ pagination: { ...detail } }, () => {
      if (startLimit < date && date < endLimit) {
        this.getbookingsList();
      } else if (fulldate === null) {
        this.getbookingsList();
      }
    });
  }

  componentDidMount() {
    let cookie = getAuthProps();
    this.setState({ adminUserId: cookie.adminUserId })
    this.getAllDropdownsForIndividualBooking();
    this.getbookingsList();
  }
  updateNewBookingDetailsById = (id) => {
    if (id > 0) {
      if (!this.isValidateAllFields()) {
        this.swalServices.Error("Please fill in all required fields correctly.");
        return;
      }
      let editViewNewBooking = this.state.editViewNewBooking
      let request = {
        bookingAttendeeInformationId: editViewNewBooking.bookingAttendeeInformationId,
        attendeeName: editViewNewBooking.attendeeName,
        contactNo: editViewNewBooking.contactNo,
        companyName: editViewNewBooking.companyName,
        emailAddress: editViewNewBooking.emailAddress,
        companyHR: editViewNewBooking.companyHR,
        adminUserId: this.state.adminUserId
      };
      this.BookingServices.updateNewBookingDetails(request).then((response) => {

        if (response.statusCode === 200 && response.responseItem != null) {
          this.swalServices.Success("Booking Details has been updated successfully");
        } else {
          this.swalServices.Error(response.message);
        }
      });
    }
    this.setState({ setEditViewNewBooking: false });
  }

  isValidateAllFields = () => {
    const newValidState = isValidForm(
      this.state.editViewNewBooking,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  validateField = (key) => {
    const newValidState = validate(
      key,
      this.state.editViewNewBooking,
      this.state.validationRule,
      this.state.validState
    );
    this.setState({ validState: newValidState });

  };

  handlechangeForEdit = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    let editViewNewBooking = { ...this.state.editViewNewBooking };
    editViewNewBooking[name] = value;

    this.setState({ editViewNewBooking });
  };



  getNewBookingDetailsById = (value) => {
    this.BookingServices.getNewBookingDetailsById(value).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let details = response.responseItem.responseContent;
        this.setState({ editViewNewBooking: details }, () => {
        });
      } else {
        this.swalServices.Error(response.message);
      }
    });
  }


  render() {
    if (this.state.route !== "") {
      return <Navigate to={this.state.route} />;
    }
    return (

      <div className="main-body-section View-booking-sec">
        <div className="custom-card">
          <div className="common-top-filter-bar">
            <div className="date-range-select">
              <input
                id="default"
                name="dateFrom"
                className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                type="date"
                value={this.state.pagination.dateFrom}
                onChange={(e) => this.handleChange(e)}
              />
              <h2 className="theme-label-left mr-0">To</h2>
              <input
                id="default"
                name="dateTo"
                className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                type="date"
                value={this.state.pagination.dateTo}
                onChange={(e) => this.handleChange(e)}
              />
            </div>
            <div className="search-bar-container">
              <div className="theme-label-left">Search</div>
              {/* <input className="col-span-2 text-lg font-bold  h-[40px] w-full text-[#757575]"/> */}
              <input
                id="default"
                className="col-span-2 text-lg font-bold  h-[55px] w-full text-[#757575] border-white"
                type="text"
                onChange={(e) => this.searchByName(e.target.value)}
              />
            </div>
          </div>

          <div className="bottom-result-table">
            {/* Table Section Start */}
            <div className="mt-10 credit-note-approval-table view-booking-table">
              <Table
                columns={[
                  { name: "BookingReferenceNo", title: "Booking Ref. No" },
                  { name: "ClassName", title: "Event Name" },
                  { name: "BookingStatus", title: "Status" },
                  { name: "AttendeeName", title: "Attendee Name" },
                  { name: "AttendeeEmail", title: "Attendee Email" },
                  { name: "BookingDate", title: "Registration Date" },
                  { name: "BookingAttendeeInformationId", title: "Actions" },
                ]}
                rows={this.state.bookingList}
                isLoading={this.state.isLoading}
                sortingColumns={["BookingReferenceNo", "ClassName"]}
                pagination={this.state.pagination}
                totalResultes={this.state.totalResultes}
                totalCount={this.state.totalResultes}
                setPagination={this.setPagination.bind(this)}
                customScope={[
                  {
                    column: "BookingAttendeeInformationId",
                    renderTableData: this.actions.bind(this),
                  },
                  // {
                  //     column: "selectRow",
                  //     renderTableData: this.select.bind(this),
                  //     valueColumnName: "chartsOfAccountsId",
                  // },
                ]}
              />
            </div>
            {/*Table Section End */}

            {/* Edit New booking starts */}
            <EditViewNewBooking
              editViewNewBooking={this.state.editViewNewBooking}
              setEditViewNewBooking={this.state.setEditViewNewBooking}
              validate={this.validateField.bind(this)}
              validState={this.state.validState}
              handlechangeForEdit={this.handlechangeForEdit}
              updateNewBookingDetailsById={this.updateNewBookingDetailsById.bind(this)}
              setOpenModal={() =>
                this.setState({ setEditViewNewBooking: false }, () => {
                  this.setState({ editViewNewBooking: {} });
                })
              }
              onClose={(e) => {
                e.stopPropagation();
                this.setState({ setEditViewNewBooking: false }, () => {
                  this.setState({ editViewNewBooking: {} });
                });
              }}
            />
            {/* Edit New booking ends */}
          </div>
        </div>

      </div>
    );
  }
}
